import table  from "assets/images/chart-images/table.png";

const revisionNumbersList = [
        {id: "AECAER#-T20r", name: "table", chartImage: table, disabled: false},
];

export default revisionNumbersList;